export default "__VITE_ASSET__iog5klau__";